import React from "react";
import classNames from "classnames";
import styles from "./TopBanner.module.css";
import { passionsIcons } from "../passions-icons";

export const TopBanner = ({ passions }) => {
  return (
    <div className={classNames(styles.wrapper, styles.banner)}>
      <h2>Your Selections Have Been Saved</h2>
      <div className={styles.header} data-passions={`${passions.length}`}>
        {passions.map((p, index) => {
          const PassionIcon = passionsIcons[p.passion];
          return (
            <div className={`${styles.icon} ${p.style}`} key={index}>
              <PassionIcon />
            </div>
          );
        })}
      </div>
    </div>
  );
};
